import * as api from "@/api/williams/project";
import { Project } from "@/api/project";
import { UseFormReturn } from "react-hook-form";

export function useProjectValidation(form: UseFormReturn<Project>) {
  return async function validate(project: Project) {
    const result = await api.validateProject(project);

    if (!result.isProjectUnique) {
      form.setError("root", { message: "Project already exists" });
    }

    return result.isProjectUnique;
  };
}
